export default "__VITE_ASSET__Dor_gLSX__"